module.exports = __webpack_public_path__ + "img/right_icon.3c1c5f8d.png";